import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import {
  IS_PROPEL_ADMINISTRATOR_KEY,
  PERMISSIONS_KEY
} from '../../constants/constants';

const _mapPermissions = permissions => {
  return permissions.map(p => p.id);
};

export const isPermissible = (
  globalProps,
  roleOrPermissionString,
  checkRole
) => {
  if (_isEmpty(globalProps)) {
    return false;
  }

  if (checkRole) {
    return (
      _get(globalProps, IS_PROPEL_ADMINISTRATOR_KEY, false) ||
      _get(globalProps, 'user.roleId', '') === roleOrPermissionString
    );
  }

  const userPermissions = _mapPermissions(
    _get(globalProps, PERMISSIONS_KEY, [])
  );
  return userPermissions.includes(roleOrPermissionString);
};

export const isPropelAdministrator = globalProps => {
  return _get(globalProps, IS_PROPEL_ADMINISTRATOR_KEY, false);
};
